import React, { useState } from 'react'
import { ApiHttpService } from 'cms/utils/http/api'
import SelectIsFeatured from 'cms/components/SelectIsFeatured'

function VideoGalleryCategoryForm({ ...props }) {

    const [title, setTitle] = useState("")
    const [is_featured, setIsFeatured] = useState(false)

    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)
    const [done, setDone] = useState(null)

    const SaveChanges = () => {

        setError(null)

        if (!title) {
            setError("Please enter title")
            return;
        }

        let body = {
            "title":title,
             "is_featured": is_featured
        }

        setLoading(true)
        ApiHttpService.saveUserGalleryCategory(body).then(data => {
            if (data.id) {
                setDone("Changes saved successfully");
                props.callback(data)
                
            }
            setLoading(false)
        })
    }


    const onChange = (e) => {
        //alert(e.target.name)
        switch (e.target.name) {
            case 'title':
                setTitle(e.target.value)
                break;
            default:

                break;
        }
    }

    const handleValue = (value, name) => {
        switch (name) {
            case "is_featured":
                setIsFeatured(value)
                break;
            default:
                break;
        }
    }


    return (
        <div className="cms-video-gallery-category-form">
            <div className="form-group">
                <input type="text" value={title} name="title" onChange={onChange} className="form-control post-title" placeholder="Title" />
            </div>
            <div className="form-group">
                <SelectIsFeatured width={"100%"} callback={handleValue} value={is_featured} />
            </div>

            <div className="form-group mt-10">
                <button className="btn btn-primary pull-right" onClick={SaveChanges}>{loading ? "" : "Save Changes"}</button>
                <div className="clear"></div>
            </div>
            {error &&
                <div className="alert alert-danger mt-5">
                    {error}
                </div>
            }
            {loading &&
                <div className="alert alert-info  mt-5">
                    Please Wait...
                </div>
            }
            {done &&
                <div className="alert alert-success  mt-5">
                    {done}
                </div>
            }





        </div>
    )
}

export default VideoGalleryCategoryForm